import {
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import API from "../../services/api";

function AddCustomer() {

  const navigate =
    useNavigate();

  const [form,
    setForm] =
    useState({
      customer_name: "",
      phone: "",
      email: "",
      gst_no: "",
      address: "",
      status: 1
    });

  const handleChange =
    (e) => {

      setForm({
        ...form,
        [e.target.name]:
          e.target.value
      });

    };

  const submit =
    async (e) => {

      e.preventDefault();

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        await API.post(
          "/customers",
          form,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        navigate(
          "/admin/customers"
        );

      } catch (err) {
        console.log(err);
      }

    };

  return (
    <div>

      <h1
        className="
        text-3xl
        font-bold
        mb-6
        "
      >
        Add Customer
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-6
        space-y-5
        "
      >

        <div>
          <label className="block mb-2">
            Customer Name
          </label>

          <input
            type="text"
            name="customer_name"
            value={form.customer_name}
            onChange={handleChange}
            required
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />
        </div>

        <div
          className="
          grid
          md:grid-cols-2
          gap-4
          "
        >

          <div>
            <label className="block mb-2">
              Phone
            </label>

            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />
          </div>

          <div>
            <label className="block mb-2">
              Email
            </label>

            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />
          </div>

        </div>

        <div>
          <label className="block mb-2">
            GST No
          </label>

          <input
            type="text"
            name="gst_no"
            value={form.gst_no}
            onChange={handleChange}
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />
        </div>

        <div>
          <label className="block mb-2">
            Address
          </label>

          <textarea
            rows="4"
            name="address"
            value={form.address}
            onChange={handleChange}
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />
        </div>

        <div>
          <label className="block mb-2">
            Status
          </label>

          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          >
            <option value={1}>
              Active
            </option>

            <option value={0}>
              Inactive
            </option>
          </select>
        </div>

        <button
          type="submit"
          className="
          bg-yellow-500
          text-black
          px-6
          py-3
          rounded-xl
          font-semibold
          "
        >
          Save Customer
        </button>

      </form>

    </div>
  );
}

export default AddCustomer;